import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import FriendIcon from '../../../Icons/Friend'
import Container from '../Container'

interface FriendButtonProps {
    shadow?: boolean
    title?: string
    color?: string
    size?: number
    filled?: boolean
    onClick?: any
}

const FriendButton = memo((props: FriendButtonProps) => {
    const { shadow = true, title, color, size, filled, onClick } = props
    return (
        <Container shadow={shadow} title={title}>
            <IconButton onClick={onClick}>
                <FriendIcon
                    color={color ?? '#eee'}
                    filled={filled}
                    size={size}
                />
            </IconButton>
        </Container>
    )
})

export default FriendButton
